import { render, staticRenderFns } from "./mailGet.vue?vue&type=template&id=7668d674&scoped=true&"
import script from "./mailGet.vue?vue&type=script&lang=js&"
export * from "./mailGet.vue?vue&type=script&lang=js&"
import style0 from "./mailGet.vue?vue&type=style&index=0&id=7668d674&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7668d674",
  null
  
)

export default component.exports